<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="false" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.$invalid" :vm-active="isModalAttachmentVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
      input(type="file" id="file" ref="file" v-on:change="handleFileUpload" accept=".pdf")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("attachments.description_placeholder")' v-model="description" :label='$t("attachments.description")' type="text")
</template>

<script>
import { required, requiredIf, alpha } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalAddAttachments',
  props: {
    isAdd: {
      default: true,
      type: Boolean
    },
    sale_id: {
      default: null,
      type: Number
    }
  },
  validations () {
    return {
      description: {
        required,
        alpha
      },
      file: {
        required: requiredIf(function () { return this.fileValidate }),
        isPDF: function (value) {
          return value && value.name.endsWith('.pdf')
        }
      }
    }
  },
  data: () => ({
    description: '',
    file: ''
  }),
  computed: {
    ...mapGetters([
      'isModalAttachmentVisible',
      'quotationFilesCatalog'
    ]),
    fileValidate () {
      return this.file.length < 1
    },
    getTitle () {
      return this.isAdd ? this.$t('strings.add') : this.$t('strings.edit')
    }
  },
  methods: {
    ...mapActions([
      'addAttachment',
      'editAttachment',
      'deleteAttachment',
      'setModalAttachmentVisible',
      'loadCatalog',
      'loadSaleRegistry'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    saveRecord () {
      this.addAttachment({ file: this.file, sale_id: this.sale_id, description: this.description }).then(() => {
        this.loadSaleRegistry({ sale_id: this.sale_id })
      })
      this.file = ''
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalAttachmentVisible(false)
      this.loadSaleRegistry({ sale_id: this.sale_id })
    }
  }
}
</script>
